<script lang="ts">
import { defineComponent } from 'vue'
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue'
import UserDataService from '@/services/UserDataService'
import type User from '@/types/User'
import type Address from '@/types/Address'
import type ResponseData from '@/types/ResponseData'
import AddressDataService from '@/services/AddressDataService'
import type ObjectConfig from '@/types/ObjectConfig'
import ServicePackageDataService from '@/services/ServicePackageDataService'
import type ServicePackage from '@/types/ServicePackage'
import moment from 'moment'
import OrderTable from '../components/OrderTable.vue'
import CompanyTable from '../components/CompanyTable.vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default defineComponent({
  name: 'user-detail',
  data() {
    return {
      currentUser: {} as User,
      currentUserAddress: {} as Address,
      userTypes: [] as ObjectConfig[],
      userStatuses: [] as ObjectConfig[],
      servicePackages: [] as ServicePackage[],
      isOpened: false,
      moment: moment(),
      id: this.$route.params.id
    }
  },
  methods: {
    getServicePackages() {
      ServicePackageDataService.getAllServicePackages()
      .then((response: ResponseData) => {
        this.servicePackages = response.data as ServicePackage[]
      })
      .catch((e: Error) => {
        toast.error('Chyba: ' + e.message)
      })
    },
    getUserTypes() {
      UserDataService.getUserTypes()
        .then((response: ResponseData) => {
          this.userTypes = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    getUserStatuses() {
      UserDataService.getUserStatuses()
        .then((response: ResponseData) => {
          this.userStatuses = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    /*getUserAddress(id: any) {
      AddressDataService.getAddressById(id)
        .then((response: ResponseData) => {
          this.currentUserAddress = response.data.data
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },*/
    getUser(id: any) {
      UserDataService.getUserById(id)
        .then((response: ResponseData) => {
          this.currentUser = response.data.data
          //this.getUserAddress(this.currentUser.address_id)
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    updateUser() {
      UserDataService.update(this.currentUser.id, this.currentUser)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava klientov' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    updateUserAddress() {
      AddressDataService.update(this.currentUserAddress.id, this.currentUserAddress)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava klientov' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    deleteUser() {
      UserDataService.delete(this.currentUser.id)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava klientov' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    sendNotification(message: any) {
      const data = {
        email: this.currentUser.email,
        message: message,
      }
      UserDataService.sendNotification(data)
        .then((response: ResponseData) => {
          this.$router.push({ name: 'Úprava klientov' })
        })
        .catch((e: Error) => {
          toast.error('Chyba: ' + e.message)
        })
    },
  },
  mounted() {
    this.getUser(this.$route.params.id)
    this.getUserStatuses()
    this.getUserTypes()
    this.getServicePackages()
  },
  components: { OrderTable, CompanyTable, PageBreadcrumb },
})
</script>

<template>
  <main>
    <div class="flex flex-row justify-between max-w-(--breakpoint-2xl) mx-auto py-6">
      <div class="basis-1/4">
        <button @click="goBack" type="button"
          class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-xs text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          Späť
        </button>
      </div>
      <div class="basis-1/4">
        <PageBreadcrumb :page-title="currentUser.id ? 'Detail klienta - ' + currentUser.id : 'Detail klienta'" />
      </div>
      <div class="basis-1/4">
        <button @click="isOpened = true" type="button"
          class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">
          Zmazať
        </button>
      </div>
    </div>
    <div v-show="isOpened" id="alert-dialog"
      class="p-4 mb-4 border border-red-300 rounded-lg bg-red-50 dark:bg-red-200 max-w-(--breakpoint-2xl) mx-auto py-6"
      role="alert">
      <div class="flex items-center">
        <svg aria-hidden="true" class="size-5 mr-2 text-red-900 dark:text-red-800" fill="currentColor"
          viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"></path>
        </svg>
        <span class="sr-only">Info</span>
        <h3 class="text-lg font-medium text-red-900 dark:text-red-800">Zmazanie záznamu z databázy</h3>
      </div>
      <div class="mt-2 mb-4 text-sm text-red-900 dark:text-red-800">
        Naozaj chcete zmazať tento záznam z databázy? Je to nenávratné :(
      </div>
      <div class="flex">
        <button type="button"
          class="text-white bg-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 mr-2 text-center inline-flex items-center dark:bg-red-800 dark:hover:bg-red-900"
          @click="deleteUser()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>

          Zmazať
        </button>
        <button type="button"
          class="text-red-900 bg-transparent border border-red-900 hover:bg-red-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1.5 text-center dark:border-red-800 dark:text-red-800 dark:hover:text-white"
          data-dismiss-target="#alert-additional-content-2" aria-label="Close" @click="isOpened = false">
          Zrušiť
        </button>
      </div>
    </div>
    <div class="max-w-(--breakpoint-2xl) mx-auto py-6">
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <div class="pb-6">
                  <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Informácie o klientovi</h3>
                </div>
                <p class="text-sm text-gray-500 dark:text-gray-400">Vyplňte všetky potrebné informácie o klientovi.</p>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="pb-6">
                <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Informácie o klientovy</h3>
              </div>
              <form @submit.prevent="updateUser">
                <div class="shadow-xs overflow-hidden sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 dark:bg-white/3">
                    <div class="grid grid-cols-6 gap-6">
                      <div class="col-span-6 sm:col-span-3">
                        <label for="first_name" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Krstné meno</label>
                        <FormKit type="text" v-model="currentUser.first_name" name="first_name" id="first_name"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="last_name" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Priezvisko</label>
                        <FormKit type="text" v-model="currentUser.last_name" name="last_name" id="last_name"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="title_before" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Titul pred
                          menom</label>
                        <FormKit type="text" v-model="currentUser.title_before" name="title_before" id="title_before"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="title_after" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Titul za menom</label>
                        <FormKit type="text" v-model="currentUser.title_after" name="title_after" id="title_after"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
                        <FormKit type="text" v-model="currentUser.email" name="email" id="email"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="phone" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Telefónne číslo</label>
                        <FormKit type="text" v-model="currentUser.phone" name="phone" id="phone"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="date_of_birth" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Dátum
                          narodenia</label>
                        <FormKit type="date" v-model="currentUser.date_of_birth" name="date_of_birth" id="date_of_birth"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="rodne_cislo" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Rodné číslo</label>
                        <FormKit type="text" v-model="currentUser.rodne_cislo" name="rodne_cislo" id="rodne_cislo"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700" />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="gender" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Pohlavie</label>
                        <FormKit type="select" v-model="currentUser.gender" name="gender" id="gender"
                          :classes="{ input: 'mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700' }">
                          <option value="">Vyberte pohlavie</option>
                          <option value="male">Muž</option>
                          <option value="female">Žena</option>
                        </FormKit>
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="status" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Stav</label>
                        <FormKit type="select" v-model="currentUser.status" name="status" id="status"
                          :classes="{ input: 'mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700' }">
                          <option value="">Vyberte stav</option>
                          <option v-for="status in userStatuses" :key="status.id" :value="status.id">{{ status.name }}
                          </option>
                        </FormKit>
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="type" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Typ účtu</label>
                        <FormKit type="select" v-model="currentUser.type" name="type" id="type"
                          :classes="{ input: 'mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700' }">
                          <option value="">Vyberte typ účtu</option>
                          <option v-for="userType in userTypes" :key="userType.id" :value="userType.id">{{ userType.name
                          }}</option>
                        </FormKit>
                      </div>
                    </div>
                  </div>
                  <div class="px-4 py-3 bg-gray-50 text-right sm:px-6 dark:bg-white/3">
                    <button type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500">
                      Uložiť
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="py-5"><div class="border-t border-gray-200 dark:border-gray-800"></div></div>
      
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Adresa</h3>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
              <form @submit.prevent="updateUserAddress">
                <div class="shadow-xs overflow-hidden sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 dark:bg-white/3">
                    <div class="grid grid-cols-6 gap-6">
                      <div class="col-span-6 sm:col-span-3">
                        <label for="city" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Mesto</label>
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.city"
                          name="city"
                          id="city"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="street" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Ulica</label>
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.street"
                          name="street"
                          id="street"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="street_number" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Súpisné číslo</label>
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.street_number"
                          name="street_number"
                          id="street_number"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="street_number2" class="block text-sm font-medium text-gray-700 dark:text-gray-300"
                          >Orientačné číslo</label
                        >
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.street_number2"
                          name="street_number2"
                          id="street_number2"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="psc" class="block text-sm font-medium text-gray-700 dark:text-gray-300">PSČ</label>
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.psc"
                          name="psc"
                          id="psc"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>

                      <div class="col-span-6 sm:col-span-3">
                        <label for="country" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Krajina</label>
                        <FormKit
                          type="text"
                          v-model="currentUserAddress.country"
                          name="country"
                          id="country"
                          class="mt-1 focus:ring-brand-500 focus:border-brand-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md dark:border-gray-700"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="px-4 py-3 bg-gray-50 text-right sm:px-6 dark:bg-white/3">
                    <button
                      type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
                    >
                      Uložiť
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      -->
      <div class="py-5">
        <div class="border-t border-gray-200 dark:border-gray-800"></div>
      </div>
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Zoznam objednávok</h3>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
              <order-table :user-id="String(id)"></order-table>
            </div>
          </div>
        </div>
      </div>

      <div class="py-5">
        <div class="border-t border-gray-200 dark:border-gray-800"></div>
      </div>
      <div class="px-4 py-6 sm:px-0">
        <div class="mt-10 sm:mt-0">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white/90">Zoznam spoločností</h3>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-3">
              <company-table :hladaj="id"></company-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
